import type { WebAccessDenial } from './webAccess';

export type AuthStatus = 'idle' | 'loading' | 'authenticated' | 'unauthenticated';

/**
 * What the /app gate should render. Session is not "ready" until tokens
 * exist AND /me has settled (status authenticated) — never paint the shell
 * with an empty permission set.
 *
 *   boot    — idle hydrate or /me in flight → full-screen loader
 *   signin  — no session → login
 *   blocked — authenticated but this surface is not for this kind/role
 *   ready   — shell + nav may render
 */
export type SessionPhase = 'boot' | 'signin' | 'blocked' | 'ready';

export function sessionPhase(input: {
  status: AuthStatus;
  accessToken: string | null;
  denial: WebAccessDenial | null;
}): SessionPhase {
  if (input.denial) return 'blocked';
  if (input.status === 'idle' || input.status === 'loading') return 'boot';
  if (input.status === 'unauthenticated' || !input.accessToken) return 'signin';
  return 'ready';
}
